import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {cart} from '../../api/cart/cart.api';
import {RequestService} from '../../../handlers/request/request.service';
import {Delete, DeleteProduct, AddProduct, GetCart} from '../../models/cart/requests/cart';
import {HandleSubstitutesReq, MergeCartReq, SubstitutesReq} from '../../models/cart/requests/substitutes-req';
import {SubstitutesRes} from '../../models/cart/responses/substitutes-res';
import {globalEnv} from '../../connection/global/global.env';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseService } from 'src/app/data/handlers/base-service/base.service';
import ScheduleResponse, { ScheduleConfig } from '../../models/schedule/schedule';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  constructor(private req: RequestService, private http: HttpClient, private baseService: BaseService) { }

  get(data: GetCart): Observable<any> {
    return this.req.post(`${globalEnv.be2}${cart.get}`, data, null);
  }

  post(data: GetCart): Observable<any> {
    return this.req.post(`${globalEnv.be2}${cart.get}`, data, null);
  }

  getAgile(data: GetCart): Observable<any> {
    return this.req.post(`${globalEnv.be2}${cart.getAgile}`, data, null);
  }

  addProduct(params: AddProduct, data?): Observable<any> {
    return this.req.post(`${globalEnv.be2}${cart.addProduct}`, ( data ), params, true);
  }

  removeProduct(params: DeleteProduct): Observable<any> {
    return this.req.delete(`${globalEnv.be2}${cart.deleteProduct}`, null, params, true);
  }

  deleteCart(params: Delete): Observable<any> {
    return this.req.delete(`${globalEnv.be2}${cart.deleteCart}`, null, params, true);
  }

  getAdvertisedItems(): Observable<any> {
    return this.req.get(`${globalEnv.be2}${cart.getAdvertisedItems}`, null, null, true);
  }

  getHighDemand(params): Observable<any> {
    return this.req.get(`${globalEnv.be2}${cart.getHighDemand}`, params);
  }

  getHighDemandVzla(params): Observable<any> {
    return this.req.get(`${globalEnv.be2}${cart.getHighDemandVzla}`, params);
  }

  getSubstitutes(data: SubstitutesReq, params): Observable<SubstitutesRes> {
    return this.req.post(`${globalEnv.be2}${cart.getSubstitutesV2}`, data, params, true);
  }

  handleSubstitutes(data: HandleSubstitutesReq): Observable<any> {
    return this.req.post(`${globalEnv.be2}${cart.handleSubstitutes}`, data);
  }

  merge(data: MergeCartReq): Observable<any> {
    return this.req.post(`${globalEnv.be2}${cart.merge}`, data);
  }

  shoppingCart(data): Observable<any> {
    return this.req.post(`${globalEnv.gateway}${cart.shoppingCart}`, data, null, false, false);
  }

  eventsTopsort(option): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer TSE_0pB6zLN14WSCjSjgZD1DR2RHUgw4oZ1UOyDr`
      }),
    };
    return this.http.post(`${cart.topsort}`, option, httpOptions );
  }

  getScheduleConfig(storeId: number, params: {'date-first-schedule'?: number}): Observable<ScheduleConfig> {
    const url = `${globalEnv.multiCountry}${cart.getScheduleConfig}`
      .replace(':storeId', storeId.toString());

    return this.baseService
      .get<ScheduleResponse>(url, {params})
      .pipe(map((response: ScheduleResponse) => response.data));
  }
}
